import {
  FeaturesAdminResponse,
  FeaturesResponse,
  FeaturesVersionResponse,
  FeatureToggleRequest,
  FeatureToggleResponse,
} from '../../types/featureTypes'
import { axiosClient } from '../axiosClient'

export const featureFunctions = {
  fetchFeatures: async (): Promise<FeaturesResponse> => {
    return await axiosClient.get('api/features/')
  },

  fetchVersion: async (): Promise<FeaturesVersionResponse> => {
    // The poll runs every few seconds; a transient failure must not toast.
    return await axiosClient.get('api/features/version', { suppressErrorToast: true })
  },

  fetchAdminList: async (): Promise<FeaturesAdminResponse> => {
    return await axiosClient.get('api/features/admin')
  },

  toggle: async (featureId: string, body: FeatureToggleRequest): Promise<FeatureToggleResponse> => {
    return await axiosClient.patch(`api/features/${encodeURIComponent(featureId)}`, body)
  },
}
